// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3FFWI","tab":"Tabs_tab__3GO2I","tabActive":"Tabs_tabActive__2GU7B"};